"use strict";
var largeImg = document.getElementById("largeImg");
var thumbs = document.getElementById("thumbs");
thumbs.addEventListener("click", function(e) {
    var link = e.target.closest("a");
    if (!link || !thumbs.contains(link)) return;
    e.preventDefault();
    largeImg.src = link.href;
});

//# sourceMappingURL=index.444158ab.js.map
